const mar = {
  "भाजपा सदस्यता अभियान - 2024": "भाजपा सदस्यता अभियान - 2024",
  "Select Language": "भाषा निवडा",
  Next: "पुढे",
  "Enter your mobile number": "आपला मोबाइल क्रमांक प्रविष्ट करा",
  "I accept the Terms and Conditions, and by continuing, I consent to voluntarily become a member of the BJP":
    "मी नियम आणि अटी मान्य करतो, आणि पुढे जाऊन, मी स्वेच्छेने भाजपाचा सदस्य होण्यास सहमती देतो.",
  "Get OTP": "ओटीपी (OTP) मिळवा",
  "Terms and Conditions": "नियम आणि अटी",
  "You must tick the box to continue, as it is mandatory.":
    "कृपया पुढे जाण्यासाठी बॉक्सवर चिन्हांकित करा, कारण हे आवश्यक आहे.",
  "Okay, Got it": "ठीक आहे, समजले.",
  "Get OTP": "ओटीपी (OTP) मिळवा",
  "Enter OTP": "ओटीपी (OTP) प्रविष्ट करा",
  "Resend OTP": "ओटीपी (OTP) पुन्हा पाठवा",
  Continue: "पुढे चला",
  "Fill details": "तपशील भरा",
  "Upload Photo": "फोटो अपलोड करा",
  "Profile Photo": "प्रोफाइल फोटो",
  "Mobile number": "मोबाइल क्रमांक",
  "Mrs.": "श्रीमती",
  "Mr.": "श्री",
  Ms: "सुश्री",
  "Full Name*": "पूर्ण नाव *",
  "D.O.B": "जन्मतारीख",
  Age: "वय",
  Gender: "लिंग",
  Female: "महिला",
  Male: "पुरुष",
  Other: "इतर",
  "Email Id": "ईमेल आयडी",
  "Add address": "पत्ता जोडा",
  "House/ Flat/ Floor No.": "घर/ फ्लॅट/ मजला क्रमांक",
  "Current address PIN code": "सध्याचा पत्ता PIN कोड",
  "District*": "जिल्हा*",
  State: "राज्य",
  "Assembly constituency (AC)": "विधानसभा मतदारसंघ (AC)",
  "Tell us about your location": "आम्हाला तुमच्या स्थानाबद्दल सांगा",
  "It will assist us in locating other members in your area.":
    "ते आम्हाला तुमच्या क्षेत्रातील इतर सदस्यांना शोधण्यात मदत करेल.",
  "Your address as fetched": "आणल्याप्रमाणे तुमचा पत्ता",
  "Referral code": "रेफरल कोड",
  "I certify that above provided information is correct and there is no mistake. I know that all further communication will be done on above provided details":
    "मी प्रमाणित करतो की वर दिलेली माहिती बरोबर आहे आणि त्यात कोणतीही चूक नाही. मला माहित आहे की पुढील सर्व संप्रेषण वरील दिलेल्या तपशीलांवर केले जाईल",
  Save: "जतन करा",
  Select: "निवडा",
  Camera: "कॅमेरा",
  or: "किंवा",
  Gallery: "गॅलरी",
  "Support format : Jpeg, Png, Pdf": "समर्थन स्वरूप: Jpeg, Png, Pdf",
  Cancel: "रद्द करा",
  "Select location": "स्थान निवडा",
  "Provide location": "स्थान द्या",
  "Search results": "शोध परिणाम",
  "Search for a building, street name or..":
    "इमारत, रस्त्याचे नाव किंवा.. शोधा.",
  "Your address as fetched": "आणल्याप्रमाणे तुमचा पत्ता",
  "Locate me": "मला शोधा",
  "Confirm location": "स्थानाची पुष्टी करा",
  "Congratulations !": "अभिनंदन!",
  "Your primary Id is -": "तुमचा प्राथमिक आयडी आहे -",
  "Login in to Bjp.org/membership to enhance your data, access your ID card, and refer others to join as primary members.":
    "Bjp.org/membership वर लॉग इन करा तुमचा डेटा वाढवण्यासाठी, तुमच्या ओळखपत्रात प्रवेश करण्यासाठी आणि इतरांना प्राथमिक सदस्य म्हणून सामील होण्यासाठी संदर्भ द्या.",
  "ID CARD": "ओळखपत्र",
  "You can download your generated ID Card":
    "तुम्ही तुमचे तयार केलेले ओळखपत्र डाउनलोड करू शकता",
  Download: "डाउनलोड करा",
  "Go to dashboard": "डॅशबोर्डवर जा",
  "View your profile": "तुमचे प्रोफाइल पहा",
  "Refer and add member": "संदर्भ घ्या आणि सदस्य जोडा",
  Share: "शेअर करा",
  "To update your additional details and refer more member, please click here.":
    "तुमचे अतिरिक्त तपशील अद्यतनित करण्यासाठी आणि अधिक सदस्यांचा संदर्भ घेण्यासाठी, कृपया येथे क्लिक करा.",
  "Bharatiya Janata Party": "भारतीय जनता पार्टी",
  "6A, DEENDAYAL UPADHYAYA MARG, NEW DELHI - 110002":
    "6A, दीनदयाल उपाध्याय मार्ग, नवी दिल्ली - 110002",
  Name: "नाव",
  "Membership Number": "सदस्य संख्या",
  "QR Code": "QR कोड",
  "Please select a year between 1930 and 2006.":
    "कृपया 1930 आणि 2006 मधील एक वर्ष निवडा.",
  "Please enter a valid email address.": "कृपया वैध ईमेल आयडी प्रविष्ट करा.",
  "Please enter 6-digit PIN code.": "कृपया 6-अंकी पिन कोड प्रविष्ट करा.",
  "10-digit mobile number.": "10-अंकी मोबाइल नंबर.",
  "Please enter a 10-digit mobile number.":
    "कृपया 10-अंकी मोबाइल नंबर प्रविष्ट करा.",
  "Please enter your name.": "कृपया आपले नाव प्रविष्ट करा.",
  "I pledge and willing to receive regular updates from BJP":
    "मी वचन देतो आणि भाजपकडून नियमित अपडेट्स प्राप्त करण्यास इच्छुक आहे. ",
  "Get Verification Code": "सत्यापन कोड मिळवा",
  "Enter Verification Code": "सत्यापन कोड प्रविष्ट करा",
  "Resend Verification Code": "सत्यापन कोड पुन्हा पाठवा",
  "Provide Details": "तपशील द्या",
  Upload: "अपलोड करा",
  Ok: "ठीक आहे",
  Calendar: "कॅलेंडर",
  "Full Address": "पूर्ण पत्ता",
  "Privacy policy": "गोपनीयता धोरण",
  Disclaimer: "अटी",
  "Contact us": "आमच्याशी संपर्क साधा",
  Save: "जतन करा",
  "Your primary member ID": "तुमची प्राथमिक सदस्य आयडी",
  "Membership Card": "सदस्यता कार्ड",
  "Your Unique Referral code": "तुमचा युनिक संदर्भ कोड",
  "Invite and add member": "निमंत्रण द्या आणि सदस्य जोडा",
  Share: "सामायिक करा",
  "Click below to add more details, donate and add other members to BJP":
    "खाली क्लिक करा, तपशील जोडा, दान करा आणि इतर सदस्य BJP मध्ये जोडा",
  "Update your details": "आपल्या विवरण अपडेट करा",
  "Add Referral Details": "संदर्भ विवरण जोडा",
  "Referred by (name)": "संदर्भित द्वारा (नाम)",
  "Referred by (mobile number)": "संदर्भित द्वारा (मोबाइल नंबर)",
  Capture: "फोटो काढा ",
  "Close Camera": "कॅमेरा बंद करा ",
  Uploading: "अपलोड करा",
  "Your Unique Referral Link": "तुमची युनिक रेफरल लिंक ",
  "You've reached the maximum OTP attempts for today. Please try again tomorrow":
    "तुम्ही आजच्या कमाल OTP प्रयत्नांवर पोहोचला आहात. कृपया उद्या पुन्हा प्रयत्न करा",
  Miss: "सौ",
  "Full Name": "पूर्ण नाव",
  "OTP limit reached for today. Please try again tomorrow":
    "आजची  OTP मर्यादा पूर्ण  झाली आहे. कृपया उद्या पुन्हा प्रयत्न करा",
  ": is not a Primary Member, Only Primary Members can refer":
    ": प्राथमिक सदस्य नाही, फक्त प्राथमिक सदस्य रेफर करू शकतात",
  "Please enter valid fullname": "कृपया वैध पूर्ण नाव टाका",
  Upload: "अपलोड करा",
};

export default mar;
